var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76713 11.8531C6.54058 17.4195 3.71459 21.4872 2.47286 20.9734C1.23114 20.4595 2.04468 15.5783 4.27122 10.0547C6.49777 4.48838 9.32376 0.420662 10.5655 0.934479C11.8072 1.4483 10.9937 6.32956 8.76713 11.8531V11.8531Z",
    fill: "url(#paint0_linear_1_261)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68154 11.8107C6.66909 16.8204 4.14282 20.4599 2.98673 20.0317C1.87346 19.5607 2.60137 15.1933 4.61382 10.1836C6.62627 5.21667 9.15254 1.53432 10.2658 1.9625C11.3791 2.4335 10.694 6.84376 8.68154 11.8107Z",
    fill: "url(#paint1_linear_1_261)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2233 1.9621C10.2233 1.9621 10.2376 1.9621 10.2661 1.9621C11.3794 2.4331 10.6943 6.84336 8.68184 11.8103C6.66939 16.82 4.14312 20.4595 2.98703 20.0313C2.98703 20.0313 2.97276 20.0171 2.94421 19.9885C4.1003 20.2883 6.58376 16.6487 8.55339 11.7674C10.523 6.88618 11.2509 2.56155 10.2233 1.9621V1.9621Z",
    fill: "#A86314"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9878 9.54041C5.25716 4.01687 8.04033 -0.093662 9.28206 0.420155L10.5666 0.933978C9.32488 0.420161 6.49888 4.48788 4.27234 10.0542C2.0458 15.5778 1.23226 20.459 2.47398 20.9729L1.23225 20.459C-0.00947055 19.988 0.761257 15.0639 2.9878 9.54041V9.54041Z",
    fill: "url(#paint2_linear_1_261)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_261",
    x1: 8.59585,
    y1: -0.949518,
    x2: 12.9205,
    y2: 0.763207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_261",
    x1: 0.803007,
    y1: -3.09004,
    x2: 14.5476,
    y2: 2.4335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_261",
    x1: -2.15038,
    y1: 19.4742,
    x2: 6.41325,
    y2: -1.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin15);
export default __webpack_public_path__ + "static/media/coin15.5d3cbd9c09f61b7d36f54f8f77020789.svg";
export { ForwardRef as ReactComponent };